import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';
import { RegistrationResult } from './classes';
import { authentication } from '../../../app-state';

// type RegistrationDetails
const register = (registrationDetails) => {
  const url = apiConstants.create;

  return httpClient.post(url, registrationDetails).then((result) => {
    console.log(result);
    const registerResult = new RegistrationResult(result.data.Success);
    return registerResult;
  });
};

// type RegistrationDetails
const login = (loginDetails) => {
  const url = apiConstants.login;
  return httpClient.post(url, loginDetails).then((res) => {
    const { data } = res;

    if (data.ValidCredentials) {
      authentication.setAuthed(true);
    }

    return data;
  });
};

const UsernameExists = (username) => {
  const url = apiConstants.usernameExists + username;
  return httpClient.get(url).then(result => result);
};

export { register, login, UsernameExists };
